import {
  FETCH_EPG_VERSION_ERROR,
  FETCH_EPG_VERSION_INIT,
  FETCH_EPG_VERSION_SUCCESS,
} from '../actions/epgVersion';

const initialState = {
  epg_version: null,
  success: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EPG_VERSION_INIT:
      return { ...state, error: null, success: false };
    case FETCH_EPG_VERSION_SUCCESS:
      return { ...state, epg_version: action.payload, error: null, success: true };
    case FETCH_EPG_VERSION_ERROR:
      return { ...state, error: action.error, success: false };
    default:
      return state;
  }
};
